import { ChangeEvent, FC, KeyboardEvent, useEffect, useState } from 'react';

import { Stack, TextField, Typography } from '@thirdspacelearning/library';

type Props = {
    name: string;
    label: string;
    value: string;
    onSubmit: (name: string, value: string) => void;
};

const sx = {
    fieldLabel: {
        fontWeight: 'SemiBold',
        color: 'grey.700',
    },
    inputField: {
        '&.MuiFormControl-root': {
            m: 0,
            width: '200px',
        },
    },
};

const InputField: FC<Props> = ({ name, label, value, onSubmit }) => {
    const [currentText, setCurrentText] = useState(value);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCurrentText(e.target.value);
    };

    const onInputEnter = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();

            onSubmit(name, currentText);
        }
    };

    useEffect(() => {
        setCurrentText(value ?? '');
    }, [value]);

    return (
        <Stack>
            <Typography
                variant="caption"
                data-testid={`filter-${name}`}
                sx={sx.fieldLabel}
            >
                {label}
            </Typography>
            <TextField
                variant={'outlined'}
                size="small"
                value={currentText}
                onChange={onChange}
                onKeyDown={onInputEnter}
                placeholder={`Search by ${label}...`}
                sx={sx.inputField}
                slotProps={{
                    htmlInput: { 'aria-label': `search-${name}` },
                }}
            />
        </Stack>
    );
};

export default InputField;
